import React from 'react';
/* Redux */
import { useSelector } from 'react-redux';
/* CSS */
import './style.css';

export const Overlay = ({ modalTarget = "", clickEvent = function() {}, children }) => {
  const isVisible = useSelector(state => state.modals[modalTarget]?.isVisible) ? true : false;

  const closeOverlay = function(event, callback) {
    const currentTarget = event.currentTarget;
    const target = event.target;

    if (currentTarget === target) {
      callback();
    }
  }

  return (
    <div className={`overlay ${isVisible ? "overlay--is-visible" : ""}`} onClick={event => closeOverlay(event, clickEvent)}>
      { children }
    </div>
  );
}
